import { PartialTranslation } from '../translations';

export const ca: PartialTranslation = {
  newChat: 'Nou xat',
  search: 'Cercar',
  user: 'Usuari',
  settings: 'Configuració',
  language: 'Idioma',
  getHelp: 'Obtenir ajuda',
  viewAllPlans: 'Veure tots els plans',
  learnMore: 'Aprendre més',
  logOut: 'Tancar sessió',
  chooseLanguage: 'Triar idioma',
  chooseYourPreferredLanguage: 'Tria el teu idioma preferit',
  searchLanguages: 'Cercar idiomes...',
  autoDetect: 'Detecció automàtica',
  noLanguagesFound: 'No s\'han trobat idiomes',
  askAnything: 'Pregunta qualsevol cosa',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Personal',
  freePlan: 'Pla gratuït',
  current: 'Actual',
  close: 'Tanca',
  archive: 'Arxivar',
  delete: 'Eliminar',
  confirmDelete: 'Estàs segur que vols eliminar aquest xat?',
  confirmArchive: 'Estàs segur que vols arxivar aquest xat?',
  deleteCannotUndo: 'Aquesta acció no es pot desfer.',
  archiveCanFind: 'Pots trobar-lo a la llista d\'arxius després d\'arxivar-lo.',
  
  // 资源面板
  resources: 'Recursos',
  addResource: 'Afegir recurs',
  deleteResource: 'Eliminar recurs',
  noMatchingResourcesFound: 'No s\'han trobat recursos coincidents',
  noResourcesAvailable: 'No hi ha recursos disponibles',
  hideResources: 'Amagar recursos',
  showResources: 'Mostrar recursos',
  
  // 聊天输入框
  typeMessage: 'Escriu un missatge...',
  thinkingOptions: 'Opcions de pensament',
  deleteFile: 'Eliminar fitxer',
  clearSelection: 'Netejar selecció',
  addAttachment: 'Afegir adjunt',
  sendMessage: 'Enviar missatge',
  
  // 思考模式选项
  deepInsight: 'Perspicàcia profunda · Anàlisi superficial',
  deepInsightDesc: 'Comprensió ràpida dels punts clau',
  deepExploration: 'Exploració profunda · Anàlisi integral',
  deepExplorationDesc: 'Recerca profunda multidimensional',
  deepDeconstruction: 'Deconstrucció profunda · Argument sistemàtic',
  deepDeconstructionDesc: 'Anàlisi progressiva capa per capa',
  
  // 写作模式选项
  contractReview: 'Revisió de contracte · Identificació de riscos',
  contractReviewDesc: 'Anàlisi de clàusules i verificació de compliment',
  textPolish: 'Poliment de text · Expressió professional',
  textPolishDesc: 'Optimització del llenguatge i ajust estructural',
  legalDocuments: 'Documents legals · Redacció estàndard',
  legalDocumentsDesc: 'Redacció professional de documents legals',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Iniciar sessió',
  register: 'Registrar-se',
  welcomeBack: 'Benvingut a LawHelper',
  loginSubtitle: 'El teu Assistent AI de Recerca Jurídica',
  continueWithGoogle: 'Continua amb Google',
  continueWithMicrosoft: 'Continua amb Microsoft',
  continueWithWeChat: 'Continua amb WeChat',
  orContinueWith: 'o continua amb',
  emailTab: 'Correu electrònic',
  phoneTab: 'Telèfon',
  emailPlaceholder: 'Introdueix el teu correu',
  phonePlaceholder: 'Introdueix el número de telèfon',
  codePlaceholder: 'Introdueix el codi de 6 dígits',
  sending: 'Enviant...',
  verifying: 'Verificant...',
  verify: 'Verificar',
  sendMagicLink: 'Envia enllaç màgic',
  getVerificationCode: 'Obtenir codi',
  resendCode: 'Reenviar codi',
  resendIn: 'Reenviar en',
  magicLinkSent: 'Enllaç màgic enviat al teu correu',
  magicLinkHint: 'T\'enviarem un enllaç segur al teu correu',
  otpSent: 'Codi de verificació enviat',
  agreeToTerms: 'En continuar, acceptes els nostres',
  privacyPolicy: 'Política de Privadesa',
  termsOfService: 'Termes del Servei',
  and: 'i',
  privacyTitle: 'La teva privadesa importa',
  privacyIntro: 'Fem servir galetes i tecnologies similars per oferir-te la millor experiència.',
  essentialCookies: 'Galetes essencials',
  essentialDesc: 'Necessàries pel funcionament del lloc',
  analyticsCookies: 'Galetes analítiques',
  analyticsDesc: 'Ens ajuden a millorar el servei',
  marketingCookies: 'Galetes de màrqueting',
  marketingDesc: 'S\'utilitzen per contingut personalitzat',
  acceptAll: 'Acceptar tot',
  essentialOnly: 'Només essencials',
  customize: 'Personalitzar',
  savePreferences: 'Desar preferències',
  back: 'Enrere',
  readPrivacyPolicy: 'Llegeix la nostra política de privadesa',
  cookiePolicy: 'Política de galetes',
  gdprCompliance: 'RGPD',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'Revisió IA',
  aiDraft: 'Esborrany IA',
  smartAssistant: 'Plantilla',

  // 知识库搜索
  enableKnowledgeSearch: 'Activa la cerca',
  knowledgeSearchDesc: 'IA cerca als teus documents',
  clickToDisable: 'Desactiva',
  clickToEnable: 'Activa',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Tancar panell de recursos',
  uploading: 'Carregant %{fileName}...',
  processing: 'Processant %{fileName}...',
  uploadSuccess: '✓ %{fileName} carregat',
  uploadError: '✗ Error en carregar: %{error}',
  quickAnswer: 'Resposta ràpida',
  quickAnswerDesc: 'Resposta ràpida a preguntes senzilles',
  cancelRequest: 'Cancel·lar',
  library: 'Biblioteca',
  filterAll: 'Tot',
  filterChat: 'Xats',
  filterReview: 'Revisió',
  filterDraft: 'Esborrany',
  filterTemplate: 'Plantilla',
  filterForm: 'Formulari',
  thinking: 'Pensant...',
  thinkingProcess: 'Procés de pensament',
  analyzingLegalLogic: 'Analitzant lògica jurídica...',
  lawhelperThinking: 'Lawhelper pensa...',
  serviceError: 'Error del servei',
  uploaded: 'Carregat',
  settingsGeneral: 'General',
  settingsNotifications: 'Notificacions',
  settingsAppearance: 'Aparença',
  settingsProfile: 'Perfil',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Mode de color',
  settingsLight: 'Clar',
  settingsDark: 'Fosc',
  settingsSystem: 'Sistema',
  about: 'Sobre',
  reviewTitle: 'Revisió de document',
  exitReview: 'Sortir de la revisió',
  uploadPrompt: 'Carregueu PDF per revisar',
  uploadButton: 'Seleccionar fitxer',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Revisant...',
  reviewComplete: 'Revisió completada',
  issuesFound: '%{count} problemes trobats',
  draftTitle: 'Redacció de document legal',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Generant...',
  generatedSuccess: '✅ Document generat!',
  drafterWelcome: 'Benvingut a l\\\'Assistent de Documents IA',
  drafterYouCan: 'Podeu:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Exemples:',
  drafterExampleRental: '"Redacteu un contracte de lloguer"',
  drafterExampleLabor: '"Ompliu el contracte laboral"',
  drafterInputPlaceholder: 'Descriviu les vostres necessitats...',
  drafterThinking: 'Pensant...',
  drafterHistoryTitle: 'Historial',
  drafterNoHistory: 'Sense historial',
  drafterNewChat: 'Xat nou',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Desar document',
  drafterDownload: 'Descarregar document',
  drafterUndo: 'Desfer',
  drafterRedo: 'Refer',
  drafterBold: 'Negreta',
  drafterItalic: 'Cursiva',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Sortir',
  drafterConfirm: 'Confirmar',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'Flux de treball IA',
  workflowRunning: 'Executant...',
  workflowReady: 'Preparat',
  workflowCompleted: 'Completat',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Acceptar canvis',
  rejectChanges: 'Rebutjar canvis',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Aturar',
  restartWorkflow: 'Restart',
  startDrafting: 'Començar redacció',
  interrupt: 'Stop',
  documentSubject: 'Tema del document *',
  documentType: 'Tipus de document',
  jurisdiction: 'Jurisdicció',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Contracte',
  docTypeAgreement: 'Acord',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Carta',
  docTypePetition: 'Petition',
  docTypeWill: 'Testament',
  docTypePowerOfAttorney: 'Poder notarial',
  countryChina: 'Xina',
  countryUSA: 'Estats Units',
  countryGermany: 'Alemanya',
  countryJapan: 'Japó',
  countryFrance: 'França',
  countryUK: 'Regne Unit',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'Assistent intel·ligent de documents',
  smartDocChatTitle: 'Assistent de Documents IA',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Seleccionar fitxer',
  smartDocOr: 'o',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'Error',
  unknownError: 'Error desconegut',
  file: 'Fitxer',
  loading: 'Carregant...',
  localFolders: 'Carpetes locals',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Desar',
  renameFile: 'Reanomenar',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'Anàlisi IA',
};
